export const CANCEL_HOTEL_ARRANGEMENT_PLAN_REQUEST =
  "CANCEL_HOTEL_ARRANGEMENT_PLAN_REQUEST";
export const CANCEL_HOTEL_ARRANGEMENT_PLAN_FAILURE =
  "CANCEL_HOTEL_ARRANGEMENT_PLAN_FAILURE";
export const CANCEL_HOTEL_ARRANGEMENT_PLAN_SUCCESS =
  "CANCEL_HOTEL_ARRANGEMENT_PLAN_SUCCESS";
